import Vue from 'vue';
import VueMeta from 'vue-meta';
import { firestorePlugin } from 'vuefire';

import router from './router';
import store from './store';
import App from './App.vue';
import wb from './registerServiceWorker';

import './index.css';

Vue.prototype.$workbox = wb;
Vue.use(firestorePlugin);
Vue.use(VueMeta);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
